import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const ABTesting = (props: SvgProps) => (
  <Svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="32" height="32" rx="8" fill="#EF196E" fillOpacity="0.05" />
    <rect
      x="0.25"
      y="0.25"
      width="31.5"
      height="31.5"
      rx="7.75"
      stroke="#EF196E"
      strokeOpacity="0.2"
      strokeWidth="0.5"
    />
    <path
      d="M17.333 9.33334V13.3333C17.3329 13.557 17.3891 13.7771 17.4963 13.9733L21.1697 20.6933C21.2808 20.8964 21.3371 21.1249 21.3331 21.3564C21.3291 21.5878 21.2649 21.8142 21.1469 22.0133C21.0288 22.2125 20.8609 22.3774 20.6598 22.492C20.4586 22.6065 20.2311 22.6667 19.9997 22.6667H11.9997C11.7682 22.6667 11.5407 22.6065 11.3395 22.492C11.1384 22.3774 10.9705 22.2125 10.8525 22.0133C10.7344 21.8142 10.6702 21.5878 10.6662 21.3564C10.6622 21.1249 10.7185 20.8964 10.8297 20.6933L14.503 13.9733C14.6103 13.7771 14.6664 13.557 14.6663 13.3333V9.33334M12.3017 18H19.6977M13.6663 9.33334H18.333"
      stroke="#EF196E"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default ABTesting;
